const MAX_LENGTH_TAG = 30;

module.exports.MAX_LENGTH_TAG = MAX_LENGTH_TAG;
